/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { RichTextWithImageComponentDisplay } from "cms/components/components/richtext-wrap-with-image/display";
import { RichTextWithImageComponentEditor } from "cms/components/components/richtext-wrap-with-image/edit";
import { getComponentZoneLayout } from "cms/components/components/component";

const RichtextWithImageComponent = (props) => {
    
    const { ...everything } = props;
    const zoneProps = {
        ...everything,
        displayComponent: <RichTextWithImageComponentDisplay />,
        editComponent: <RichTextWithImageComponentEditor />,
    };
    return getComponentZoneLayout(zoneProps);
};

RichtextWithImageComponent.displayName = "RichtextWithImageComponent";
export { RichtextWithImageComponent };
